import { render } from "./DefaultAppBar.vue?vue&type=template&id=5966f4e5"
import script from "./DefaultAppBar.vue?vue&type=script&lang=js"
export * from "./DefaultAppBar.vue?vue&type=script&lang=js"

import "@/styles/global.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__